import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import type { NavEntry, NavGroup, NavItem } from '@/navigation/navItems';
import { Perm } from '@/auth/permissions';
import { Modules } from '@/core/modules/moduleKeys';

const item = (label: string, path: string, icon: NavItem['icon']): NavItem => ({ label, path, icon, module: Modules.Accounting, permission: Perm.Budgeting.View });

/**
 * Budgeting's navigation: a Budgeting group inside the Accounting menu (budgeting is part of the Accounting module,
 * docs §206). Shown only where the organisation has Accounting on.
 */
export const budgetingNavEntries: NavEntry[] = [
  item('Overview', '/budgeting', DashboardOutlinedIcon),
  item('Budget Cycle', '/budgeting/cycle', EventRepeatOutlinedIcon),
  item('Preparation', '/budgeting/preparation', EditNoteOutlinedIcon),
  item('Methods', '/budgeting/methods', FunctionsOutlinedIcon),
  item('Review', '/budgeting/review', GavelOutlinedIcon),
  item('Execution', '/budgeting/execution', PaymentsOutlinedIcon),
  item('Changes', '/budgeting/changes', SwapHorizOutlinedIcon),
  item('Performance', '/budgeting/performance', InsightsOutlinedIcon),
  item('Company and Accrual', '/budgeting/company', BusinessOutlinedIcon),
  item('Structure', '/budgeting/structure', AccountTreeOutlinedIcon),
  item('Budgeting Settings', '/budgeting/settings', SettingsOutlinedIcon),
];

export const budgetingNavGroup: NavGroup = {
  kind: 'group', key: 'budgeting', label: 'Budgeting', icon: AccountBalanceWalletOutlinedIcon, items: budgetingNavEntries,
};
